import { query } from "../db.js";

async function setReadMessage(remoteJid) {
    try {
        await query(
            `UPDATE whatsapp_messages SET status = $1 WHERE to_number = $2`,
            ["read", remoteJid]
        );
    } catch (error) {
        console.error("Failed to update read message:", error.message);
        throw error;
    }
}

async function markMessageAsRead(socket, message) {
    try {
        if (message.key.participant) {
            // Group chat
            await socket.sendReceipt(
                message.key.remoteJid,
                message.key.participant,
                [message.key.id],
                "read"
            );
        } else {
            // Private chat
            await socket.readMessages([message.key]);
            await setReadMessage(message.key.remoteJid);
        }
        console.log(`✅ Marked message ${message.key.id} as read`);
    } catch (err) {
        console.error("❌ Failed to mark message as read:", err);
    }
}

export { markMessageAsRead };
